// extracted by mini-css-extract-plugin
export default {"TextPhotoWrapper":"TextPhoto_TextPhotoWrapper__jIBMw"};